export default __webpack_public_path__ + "static/media/andox.3282dc1d.jpeg";